import { gql } from 'apollo-boost';

export const GET_ACTIVATION_URL = gql`
  query GetActivationUrl {
    getActivationUrl {
      url
    }
  }
`;
